var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.855 5.354l1.416 1.415M10.09 3.496v2M4.997 10.59h-2M19.145 19.644L17.73 18.23M13.91 21.503v-2.001M19.003 14.408h2M12 17.502l-1.5 1.5a3.536 3.536 0 01-5.002 0v0a3.536 3.536 0 010-5.001l1.5-1.501M12 7.498l1.5-1.5a3.537 3.537 0 015.003 0v0a3.536 3.536 0 010 5.001l-1.5 1.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUnlink;